enum MotionDurations {
	Fast = 200,
	Normal = 300,
	Slow = 400,
}

export default MotionDurations;
